export enum AppType {
	FREE,
	FREEMIUM,
	PREMIUM,
}
